// config-budget-ceilings.ts
//
// 06g R5 (audit M2, debate D1): a mission ALWAYS runs under a cost + attempt
// ceiling. These are the schema defaults ($25 / 60) and the sentence the
// schema returns for `0`/negative — one place, imported by config-schema.ts
// and the status readers (DRY). Kept out of config-schema.ts for its 200-line budget.
export const DEFAULT_MAX_COST_USD_PER_MISSION = 25;
export const DEFAULT_MAX_ATTEMPTS_PER_MISSION = 60;
export const BUDGET_CEILING_MUST_BE_POSITIVE =
  "phải > 0 — 0 = không giới hạn không còn được chấp nhận (trần chi phí/attempt bắt buộc, mặc định $25 / 60)";
